<template>
  <div class="userInfo">
    <h3 v-if="type === 'edit'">修改开发者信息</h3>
    <h3 v-else>
      开发者信息<i
        class="el-icon-edit"
        @click="handelEdit"></i>
    </h3>
    <el-form
      ref="editorForm"
      class="editor-form"
      :model="form"
      label-width="150px"
      label-position="right">
      <el-form-item
        prop="email"
        label="账号：">
        <span>{{ form.email }}</span>
      </el-form-item>
      <!--  <el-form-item
        label="原密码："
        prop="old_pwd"
        v-if="type === 'edit'">
        <el-input
          v-model.trim="form.old_pwd"
          show-password></el-input>
      </el-form-item>
      <el-form-item
        label="新密码："
        prop="new_pwd1"
        v-if="type === 'edit'">
        <el-input
          v-model.trim="form.new_pwd1"
          show-password></el-input>
      </el-form-item>
      <el-form-item
        label="确认密码："
        prop="new_pwd2"
        v-if="type === 'edit'">
        <el-input
          v-model.trim="form.new_pwd2"
          show-password></el-input>
      </el-form-item> -->
      <div class="title">企业信息</div>
      <el-form-item
        prop="company"
        label="企业全称/工作室名称：">
        <el-input
          v-if="type === 'edit'"
          v-model="form.company"
          placeholder="请输入企业全称/工作室名称">
        </el-input>
        <span v-else>{{ form.company }}</span>
      </el-form-item>
      <el-form-item
        prop="company_addr"
        label="企业地址/工作室地址：">
        <el-input
          v-if="type === 'edit'"
          v-model="form.company_addr"
          placeholder="请输入企业地址/工作室地址">
        </el-input>
        <span v-else>{{ form.company_addr }}</span>
      </el-form-item>
      <div class="title">联系人信息</div>
      <el-form-item
        prop="contacts"
        label="联系人：">
        <el-input
          v-if="type === 'edit'"
          v-model="form.contacts"
          placeholder="请输入联系人">
        </el-input>
        <span v-else>{{ form.contacts }}</span>
      </el-form-item>
      <el-form-item
        prop="mobile"
        label="手机号码：">
        <el-input
          v-if="type === 'edit'"
          v-model="form.mobile"
          placeholder="请输入手机号码">
        </el-input>
        <span v-else>{{ form.mobile }}</span>
      </el-form-item>
      <div
        class="btns flex flex-center"
        v-if="type === 'edit'">
        <el-button
          type="primary"
          @click="handleConfirm">
          确定
        </el-button>
        <el-button @click="resetForm">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { editOpenUserInfo, getOpenUserInfo } from '@/api/application';
import { useUserStore } from '@/store/index';

export default {
  data() {
    return {
      type: 'detail',
      form: {
        email: '',
        company: '',
        company_addr: '',
        contacts: '',
        mobile: '',
        old_pwd: '',
        new_pwd1: '',
        new_pwd2: '',
      },
    };
  },
  methods: {
    getDetails() {
      getOpenUserInfo().then((res) => {
        this.form = res.data;
      });
    },
    handelEdit() {
      this.type = 'edit';
    },
    handleConfirm() {
      editOpenUserInfo(this.form).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: 'success',
          });
          this.type = 'detail';
          if (
            this.form.old_pwd !== '' &&
            this.form.new_pwd1 !== '' &&
            this.form.new_pwd2 !== ''
          ) {
            useUserStore().resetToken();
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error',
          });
        }
      });
    },
    resetForm() {
      this.type = 'detail';
    },
  },
  mounted() {
    this.type = 'detail';
    this.getDetails();
  },
};
</script>

<style lang="scss">
.userInfo {
  padding: 30px;
  .el-form-item__content {
    display: flex;
  }
  .el-form-item__label {
    font-weight: bold;
    width: auto !important;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.userInfo {
  padding: 30px;
  .editor-form {
    width: 500px;
  }
  .el-icon-edit {
    font-size: 25px;
    margin-left: 10px;
  }
  .title {
    font-size: 15px;
    font-weight: bolder;
    margin: 30px 0;
  }
  h3 {
    color: #5b03e4;
    font-size: 20px;
    margin-bottom: 30px;
  }
}
/* Your styles */
</style>
